import useProjectType from '@/hooks/useProjectType'
import ProjectsList from '@/components/ProjectList'
import { useEffect, useState } from 'react'
import { ProjectType } from '@/features/apiSliceWithProjects'

export default function ProjectListProvider() {
  const activeType = useProjectType()
  const [visitedTypes, setVisitedTypes] = useState<ProjectType[]>([activeType])

  useEffect(() => {
    setVisitedTypes(prev => {
      if (prev.includes(activeType)) return prev

      return [...prev, activeType]
    })
  }, [activeType])

  return (
    <>
      {[ProjectType.Invited, ProjectType.Admin, ProjectType.Managed].map((type) => (
        visitedTypes.includes(type) && (
          <div
            key={type}
            style={{ display: type === activeType ? 'block' : 'none' }}
          >
            <ProjectsList projectType={type} />
          </div>
        )
      ))}
    </>
  )
}
